<mat-card class="summary-card today">
	<div class="summary-title today">TODAY</div>
	<div class="summary-content">
		<!-- Repeat for each metric -->
		<div class="summary-metric">
			<span class="metric-label">TOTAL SALES</span>
			<span class="metric-value">{{ totalSalesToday | currency:'USD':'symbol':'1.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">TOTAL ORDERS / ITEMS</span>
			<span class="metric-value">{{ totalOrdersItems }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ salesValuePerItem | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">AVERAGE ORDER $</span>
			<span class="metric-value">{{ averageOrderValue | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI SALES</span>
			<span class="metric-value">{{ sushiSalesToday | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI ITEM SOLD</span>
			<span class="metric-value">{{ sushiItemsSoldToday | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO SALES</span>
			<span class="metric-value">{{ bentoSalesToday | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO ITEM SOLD</span>
			<span class="metric-value">{{ bentoItemsSoldToday | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON SALES</span>
			<span class="metric-value">{{ commonSalesToday | currency:'USD':'symbol':'1.2-2'}}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON ITEM SOLD</span>
			<span class="metric-value">{{ commonItemsSoldToday | number:'0.0-0'}}</span>
		</div>
	</div>
</mat-card>